// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuElements_menu__1iRK2","menu__wrapper":"MenuElements_menu__wrapper__2zCOI","menu__header":"MenuElements_menu__header__2ehUH"};